import { render, staticRenderFns } from "./WebhookList.vue?vue&type=template&id=560ce762"
import script from "./WebhookList.vue?vue&type=script&lang=js"
export * from "./WebhookList.vue?vue&type=script&lang=js"
import style0 from "./WebhookList.vue?vue&type=style&index=0&id=560ce762&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports